import React, {useState, useEffect} from "react";
import { connect, useSelector } from "react-redux";
import { setContractDrop, getContract, deleteContract, createContract, getAcceptedContract, getContractInvitations, editContract, discardContractDraft, clearContract, clearInvitations, respondToContractInvitation, respondToApprovalInvitation } from "../../actions/contract";
import { setInvoiceDrop } from "../../actions/invoices";
import { setProjectDrop } from "../../actions/projects";
import { uploadFileAttachment, editContractAttachment, setActiveSidebarPage } from "../../actions/core";
import { createMessage } from "../../actions/messages";
import { getCompanies } from "../../actions/company";
import { alertPermissionsRequired } from "../../actions/messages";
import WorkflowParties from "./WorkflowParties";
import WorkflowDetailsInfo from "./WorkflowDetailsInfo";
import WorkflowDetailsEdit from "./WorkflowDetailsEdit";
import axios from 'axios';
import WorkflowWizard from "./WorkflowWizard";
import {Link} from "react-router-dom";
import {logout} from "../../actions/auth";
import Warning from "../common/Warning";
import Modal from "../common/Modal/Modal";
import ConfirmationModal from "../common/Modal/ConfirmationModal";
// import {newContractValues5} from "../common/TestData";
import Crayon from "../iconComponents/Crayon";
import IconTrash from "../iconComponents/IconTrash";
import AppendProjectModal from "./AppendProjectModal";

export function WorkflowSingle(props) {
    
    // GLOBAL STATE --------------------------------------------------------------------------------------------------------------------------
    const contract = useSelector(state => state.contract.contract);
    const contracts = useSelector(state => state.contract.contracts);
    // TESTING FAKE DATA:  
    // const contract_ = useSelector(state => state.contract.contract);
    // const contract = {...contract_, ...newContractValues5}
    const invitations = useSelector(state => state.contract.invitations);
    const project = useSelector(state => state.projects.project);
    const token = useSelector(state => state.auth.token);
    const user = useSelector(state => state.auth.user);
    const sidebarActivePage = useSelector(state => state.core.sidebarActivePage);
    const projectDrop = useSelector(state => state.projects.projectDrop);
    const contractDrop = useSelector(state => state.contract.contractDrop);
    const invoiceDrop = useSelector(state => state.invoices.invoiceDrop);

    // LOCAL STATE --------------------------------------------------------------------------------------------------------------------------
    const [initialDetails, setInitialDetails] = useState(null);
    const [initialParties, setInitialParties] = useState(null);
    const [newDetails, setNewDetails] = useState({contract_name: null});
    const [newParties, setNewParties] = useState({PCA: null, AP: null, APP1: null, VCA: null, AR: null, template_id: contract.template_id || null});
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [removedFiles, setRemovedFiles] = useState([]);
    const [render, setRender] = useState(props.match.params.id === contract.contract_id);
    const [rejectionRedirect, setRejecionRedirect] = useState(false);
    const [contractClosureModalOpen, setContractClosureModalOpen] = useState(false);
    const [closeReqRejectModalOpen, setCloseReqRejectModalOpen] = useState(false);
    const [editPartiesHovered, setEditPartiesHovered] = useState(false);
    const [editDetailsHovered, setEditDetailsHovered] = useState(false);
    const [projectModalOpen, setProjectModalOpen] = useState(false);
    const [newContractCreated, setNewContractCreated] = useState(false);
    const [deletionModalOpen, setDeletionModalOpen] = useState(false);
    const [trashIsHovered, setTrashIsHovered] = useState(false);
    const [submittingParties, setSubmittingParties] = useState(false);
    const [submittingDetails, setSubmittingDetails] = useState(false);
    const [rejectionReason, setRejectionReason] = useState("");

    // opposing party on this contract
    const otherParty = contract.PCA?.email ? (user.email === contract.PCA?.email ? "Vendor" : "Purchaser") : null ;
    const contractStatusAllowsClosure = (contract.contract_status === "Active" || contract.contract_status === "Close Requested") || contract.contract_status === "Pending" && !contract.contract_shared;
    // all conditions are met for this user to be involved in closing this contract (contract status allows it, user is PCA/VCA, no invoices are ongoing)
    const canCloseContract =  contractStatusAllowsClosure && contract.contract_closeable && (user.email === contract.PCA?.email || user.email == contract.VCA?.email);
    // all conditions are met for this user to be involved in closing this contract EXCEPT that there is still an ongoing invoice associated with it (contract status allows it, user is PCA/VCA, invoices are ongoing)
    const canCloseContractIfNoInvs = contractStatusAllowsClosure && (user.email === contract.PCA?.email || user.email == contract.VCA?.email);
    // this user can close the contract (or send the request to have it closed)
    const canStartClose = canCloseContract && contract.contract_status !== "Close Requested";
    // this user can close the contract (or send the request to have it closed) IF there are no ongoing invoices
    const canStartCloseIfNoInvs = canCloseContractIfNoInvs && contract.contract_status !== "Close Requested";
    // closure has been requested, and this user is responsible/able to respond
    const canFinishClose =  canCloseContract && contract.contract_status == "Close Requested" && contract.request_from == otherParty;
    // closure has been requested, but user is not responsible/able to respond
    const cantFinishReqdClose = contract.contract_status == "Close Requested" && (contract.request_from !== otherParty || !canCloseContract);
    const userIsRep = (user?.email === contract?.PCA?.email) || (user?.email == contract?.VCA?.email)
    const userCanEditContract = user?.croles?.Creator && (userIsRep || contract.contract_status == "Draft") && contract?.invitations?.length < 1;
    // A Basic-tier company is always exactly one person, so once the contract is past Draft
    // (the only stage where the PCA/VCA rep email itself can still change) there is nothing left
    // for that side to edit here -- AP/AR and the approval workflow are always themselves, enforced
    // server-side regardless of what this button would otherwise let them submit.
    const userSideIsBasic =
        (user?.email === contract?.PCA?.email && contract?.fk_company_purchaser?.is_basic) ||
        (user?.email === contract?.VCA?.email && contract?.fk_company_vendor?.is_basic);

    // ON MOUNT
    useEffect(() => {
        sidebarActivePage !== "mng" && props.setActiveSidebarPage("mng");
        // determine whether contract is an invitation
    }, []);

    // ON MOUNT OR SWITCH CONTRACTS, GET CONTRACT 
    useEffect(() => {
        if (props.match.params.id !== contract.contract_id) {
            render && setRender(false);
            if (props.match.params.id === "new") {
                contract.contract_id && props.clearContract();
            } else {
                props.getContract(props.match.params.id);
            }
            setNewDetails({contract_name: null});
            setNewParties({PCA: null, AP: null, APP1: null, VCA: null, AR: null, template_id: null});
            setSelectedFiles([]);
            setRemovedFiles([]);
        }
        // if there is a change to the url id (a different contract was selected when this component was already mounted), clear the form and load the new contract
    }, [props.match.params.id]);

    // WHEN CORRECT DATA ARRIVES
        // make sure drops match
        // then render
    useEffect(() => {
        const newReady = props.match.params.id === "new" && !contract.contract_id;
        const existingReady = contract.contract_id === props.match.params.id;
        if (newReady || existingReady) {
            if (existingReady) {
                (projectDrop.project_id !== contract.project_id) && props.setProjectDrop({project_id: contract.project_id, project_name: contract.project_name});
                (contractDrop.contract_id !== contract.contract_id) && props.setContractDrop({project_id: contract.project_id, project_name: contract.project_name, contract_name: contract.contract_name, contract_id: contract.contract_id});
                (invoiceDrop.contract_id && invoiceDrop.contract_id !== contract.contract_id) && props.setInvoiceDrop({});        
            }
            !render && setRender(true);
        } 
    }, [contract.contract_id]);

    // INITIALIZE STATE before editing
    useEffect(() => {
        // when the Contract mounts, getContract has been called but res.data may not have arrived back yet
        // once the contract data arrives, use it to initialize both the state for the forms (newDetails, newParties) and a reference for their initial values (initialDetails, initialParties)
        // run if contract updates from form submission (Note: only major change will be resetting of "existing" values, used to identify form updates, enabling submit button. However, whole function should run in case anything does return correctly per form submission)
        if (contract.contract_id && contract.contract_id !== undefined) {
            // SET ITINITIAL FORM DETAILS
            let defaultDurationPayment = contract.contract_name ? contract.duration_payment : "28";
            let defaultDurationReview = contract.contract_name ? contract.duration_review : "14";
            let ExistingDetails = {
                project_name: contract.project_name, 
                project_id: contract.project_id, 
                contract_name: contract.contract_name, 
                contract_value: contract.contract_value, 
                contract_number: contract.contract_number, 
                duration_payment: defaultDurationPayment, 
                duration_review: defaultDurationReview
            };
            setInitialDetails(ExistingDetails);
            setNewDetails(ExistingDetails);
            // SET FORM PARTIES
            // set regular roles
            // suggested_pca_email (set server-side, get_contract_response) is only ever present
            // when this Contract came from a plainly-Accepted Quote the Vendor is now manually
            // converting, and only while no PCA role has been assigned yet -- pre-fills the field
            // as a smarter default, not a granted role, so it's still fully editable/overridable
            let existingBaseRoles = {
                PCA: contract.PCA.email || contract.suggested_pca_email || null,
                AP: contract.AP.email,
                VCA: contract.VCA.email,
                AR: contract.AR.email,
                template_id: contract.template_id || null
            }
            // set workflow roles (result is array of objects). Keyed positionally (APP1..APPn, by
            // order) rather than by approval_level.name -- that's free text on a custom template
            // (e.g. "Manager Approval") and only ever equalled "APP1"/"APP2" by seed-data coincidence
            // for the 2 global templates.
            let  existingAppLevelsArray = contract.approval_levels.map((approval_level, index) => {
                const key = "APP" + (index + 1);
                if (approval_level.parties.length > 0) {
                    return {[key]: approval_level.parties[0].email};
                } else {
                    return {[key]: null};
                }
            });
            // convert array of workflow role objects into a single object
            let existingAppLevels = Object.assign({}, ...existingAppLevelsArray);
            // combine regular roles and workflow roles objects into one object
            let existingParties = {
                ...existingBaseRoles,
                ...existingAppLevels
            }
            // set the state for the form and initial form reference using the combined parties object
            setNewParties(existingParties);
            setInitialParties(existingParties);
        }
    },[contract]);

    // EDIT DETAILS 
    const handleClickEditDetails =(e) => {
        setEditDetailsHovered(false);
        userCanEditContract ? onLink(`/mng/workflow/editdetails/${contract.contract_id}`) : props.alertPermissionsRequired();
    }

    const onChangeDetails = (e) => { 
        e.target.value === "" 
        ? setNewDetails({...newDetails, [e.target.id]: null})
        : setNewDetails({...newDetails, [e.target.id]: e.target.value}) 
    };
    const handleBlurCurrency = (e) => {
        let valueWithDecimals = parseFloat(e.target.value).toFixed(2);
        e.target.value === "" 
        ? setNewDetails({...newDetails, [e.target.id]: null})
        : setNewDetails({...newDetails, [e.target.id]: valueWithDecimals});
    }

    // EDIT ATTACHMENTS (part of details)
    const downloadAttachment = (id, file_name) => {
        const fileDownload = require("js-file-download");
        axios.get(`/v0/api/core/download/${id}/`, { 
            responseType: "blob",
            headers: {"Authorization": `Token ${token}`}
        }).then(res => {
            fileDownload(res.data, file_name);
            //console.log(res);
        }).catch(err => {
            console.log(err);
        })
    }
    const removeSelectedFile = (file_path) => { 
        setSelectedFiles(selectedFiles.filter((file) => file.path !== file_path));
    }
    const removeUploadedFile = (id) => {
        setRemovedFiles(removedFiles => [...removedFiles, id])
    }
    const clearUploadInfo = () => {
        setSelectedFiles([]);
        setRemovedFiles([]);
    }
    const handleDrop = (files) => { 
        files.map(file => {
            let file_exists = undefined;
            file_exists = selectedFiles.find( ({ path }) => path === file.path );
            if (file_exists == undefined) {
                setSelectedFiles(selectedFiles => [...selectedFiles, file]);
            }
        });
    }

    // TRACK DETAILS CHANGES
    const detailChanges = 
        JSON.stringify(newDetails) !== JSON.stringify(initialDetails) || 
        removedFiles.length > 0 || 
        selectedFiles.length > 0

    // SUBMIT DETAILS
    const onSubmitDetails = (e) => {
        e.preventDefault();
        if (submittingDetails) return;
        setSubmittingDetails(true);
        /* SUBMIT ATTACHMENTS -----*/
        selectedFiles.map(file => {
            // Initial FormData
            const formData = new FormData();
            formData.append("attachment", file);
            //formData.append("timestamp", (Date.now() / 1000) | 0);
            props.uploadFileAttachment("Contract", contract.contract_id, file.path, formData)
        });
        setSelectedFiles([]);
        removedFiles.map(file => {
            props.editContractAttachment(file);
        });
        setRemovedFiles([]);
        /* -----------------------*/
        const message1 = "Contract Draft details saved";
        const message2 = "Contract details updated. All parties notified.";
        const message3 = "Contract details saved.";
        if (!contract.contract_id) {
            props.createContract(newDetails, message3);
            setNewContractCreated(true);
        } else if (contract.contract_status === "Draft") {
            props.editContract(contract.contract_id, newDetails, message1);
            props.history.push(`/mng/workflow/editparties/${contract.contract_id}`);
        } else {
            props.editContract(contract.contract_id, newDetails, message2); 
            props.history.push(`/mng/workflow/view/${contract.contract_id}`);  
            window.scrollTo(0, 0); 
        }
    };

    useEffect(() => {
        if (newContractCreated && contract.contract_id) {
            props.history.push(`/mng/workflow/editparties/${contract.contract_id}`)
            setNewContractCreated(false);
            setSubmittingDetails(false);
        }
    }, [newContractCreated, contract.contract_id])

    // EDIT PARTIES

    const handleClickEditParties = (e) => {
        setEditPartiesHovered(false);
        userCanEditContract ? onLink(`/mng/workflow/editparties/${contract.contract_id}`) : props.alertPermissionsRequired();
    }

    const onChangeParties = (e) => {
        setNewParties({...newParties, [e.target.id]: e.target.value === "" ? null : e.target.value});
    }

    // the stage list currently driving the parties form: the contract's own approval_levels while
    // the selected template hasn't changed, or the freshly-fetched stage list for a newly picked
    // template (WorkflowParties dispatches getApprovalWorkflowStages when the PCA picks a different one)
    const fetchedTemplateStages = useSelector(state => state.approvalWorkflow.stages);
    const templateChanged = newParties.template_id && newParties.template_id !== contract.template_id;
    const activeStages = templateChanged ? fetchedTemplateStages : (contract.approval_levels || []);

    const onSelectTemplate = (template) => {
        // clear every existing APP{n} slot -- the new template may have a different stage count,
        // and we don't know it synchronously (its stage list is still being fetched)
        const cleared = {...newParties};
        Object.keys(cleared).forEach((key) => { if (/^APP\d+$/.test(key)) cleared[key] = null; });
        setNewParties({...cleared, template_id: template.uuid});
    }

    // TRACK PARTIES CHANGES
    const up = JSON.stringify(newParties) === JSON.stringify(initialParties) ? "False" : "True";

    const onCancelPartyChanges = (e) => {
        e.preventDefault();
        setNewParties(initialParties);
            props.history.push(`/mng/workflow/view/${contract.contract_id}`);
    }

    // SUBMIT PARTIES
    const onSubmitParties = (e) => {
        e.preventDefault();
        if (submittingParties) return;
        // console.log("up: " + up);
        if (userCanEditContract) {
            setSubmittingParties(true);
            const wasDraft = contract.contract_status === "Draft";
            const message = wasDraft
                ? "Contract invitations sent to all parties"
                : "Contract parties updated";
            // assemble the ordered stage_approvers list the backend expects from the current
            // APP1..APPn state keys, against whichever stage list is currently driving the form
            const stage_approvers = activeStages.map((stage, index) => ({
                order: index + 1,
                email: newParties["APP" + (index + 1)]
            }));
            props.editContract(contract.contract_id, {...newParties, stage_approvers, up}, message);
            props.history.push(`/mng/workflow/view/${contract.contract_id}`);
            // clear parties? Or update them when contract.parties chagne
        }
    };

    // ANSWER INVITE
    // responseType ("Decline" | "RequestRevision") only matters when status === "Rejected",
    // mirroring Quote's three-way response (see GitHub #632): Decline terminates the Contract
    // outright, RequestRevision (the default) bounces it back to Draft with a required reason.
    const handleAnswerInvite = (inviteId, role, status, responseType = "RequestRevision") => {
        status === "Rejected" && setRejecionRedirect(true);
        let permissionsRequired = role === "VCA" || role === "PCA";
        let userHasPermissions = user.croles.Creator;
        // if user is declining or is accepting with sufficent permissions, respond to the invite
        if (userHasPermissions || !permissionsRequired || status === "Rejected") {
            // if user is accepting, but contract doesn't have a project assigned to it, assign one/create one for it
            if (status === "Active" && !contract.project_id) {
                setProjectModalOpen(true);
            } else {
                let multipleInvites = contract.invitations.length > 1;
                let existing = contracts.filter(item => item.contract_id === contract.contract_id).length > 0;
                //a reason is only sent for a PCA/VCA RequestRevision (see GitHub #632) -- an APP
                //(approval-stage) invite keeps its existing no-reason behavior, and Decline needs
                //no reason either, matching Quote's Decline
                let body = (status === "Rejected" && !role.startsWith("APP"))
                    ? {status: status, response: responseType, rejection_reason: responseType === "RequestRevision" ? rejectionReason : null}
                    : {status: status};
                role.startsWith("APP")
                ? props.respondToApprovalInvitation(inviteId, body, contract.contract_id, existing)
                : props.respondToContractInvitation(inviteId, body, contract.contract_id, existing)
                if (status === "Rejected" && !multipleInvites) {
                    props.history.push(`/mng/workflows/list`);
                }
            }
        } else {
            // if user tries to accept without sufficient company permissions, alert permissions required
            props.alertPermissionsRequired();
        }
    }
    useEffect(() => {
        // once an invite is responded to, getContracts again to render updated party & contract status
        if (contract.invitations) {
            let relevantInvites = invitations.filter(invite => invite.contract_id === contract.contract_id);
            if (contract.invitations.length !== relevantInvites.length && !rejectionRedirect) {
                props.getAcceptedContract(contract.contract_id);
            }
        }
    }, [invitations]);

    // SWITCH MODES
    const onLink = (url) => {
        props.history.push(url)
    }

    const cancelEditContract = () => {
        setNewDetails(initialDetails);
        if (contract.contract_name) {
            props.history.push(`/mng/workflow/view/${contract.contract_id}`);
        } else {     
            props.discardContractDraft(contract.contract_id);
            props.history.push(`/mng/workflows/list`);
        }
    }

    const handleStartClose = (e) => {
        e.preventDefault();
        if (contract.contract_closeable) {
            setContractClosureModalOpen(true);
        } else {
            props.createMessage({info: "This Contract cannot be closed as there is at least one related invoice that is still ongoing. Close out all related invoices, then try again."})
        }
    }

    const handleCloseContract = (e) => {
        e.preventDefault();
        // if the contract has already been requested to be closed by the other party
        if (contract.contract_status == "Close Requested") {
            const message = "This Contract was successfully closed";
            props.editContract(contract.contract_id, {close_req_res: true}, message);
            setContractClosureModalOpen(false);
        } else if (contractStatusAllowsClosure) {
            const message = contract.contract_shared ? `Close request sent to ${otherParty}` : "This Contract was successfully closed";
            props.editContract(contract.contract_id, {close_req: true}, message);
            setContractClosureModalOpen(false);
        } 
    }

    const handleDeleteDraft = () => {
        let contractName = contract.contract_name ? contract.contract_name : "Untitled Draft"
        props.deleteContract(contract.contract_id, contractName);
        props.history.push("/mng/workflows/list");
    }

    const handleRejectClose = (e) => {
        e.preventDefault();
        const message = "Closure request rejected. Contract will remain open.";
        props.editContract(contract.contract_id, {close_req_res: false}, message);
        setCloseReqRejectModalOpen(false);
    }

    const myRole = (role) => {
        switch(role) {
            case "PCA": return "Purchaser Rep";
            case "VCA": return "Vendor Rep";
            case "AR": return "Accounts Receivable";
            case "AP": return "Accounts Payable";
            case "APP1": return "Approver 1";
            case "APP2": return "Approver 2";
            // any other approval stage role is a custom template's free-text stage name (e.g.
            // "Manager Approval") -- already human-readable, display as-is
            default: return role;
        }
    }

// later consider: can we close a contract which is shared & Pending? this would effectively be canceling it
/* 
// add button to heading
// ensure modal closes on contract update
*/

    return (
        <>
            {projectModalOpen && 
            <AppendProjectModal setProjectModalOpen={setProjectModalOpen} answerInvite={() => handleAnswerInvite(contract.invitations?.[0]?.role_id, contract.invitations?.[0]?.role, "Active")} /> }

            {contract.error && 
            <Modal blurBack={true} hasCloseButton={true} handleClose={() => props.history.push("/mng/workflows/list")} >{contract.error}</Modal>}

            {contractClosureModalOpen &&
            <Modal blurBack={true} hasCloseButton={true} handleClose={() => setContractClosureModalOpen(false)} >
                <div className="flex-column space-btwn flex1 w100" >
                    <p className="content1 light-black multiline gap-below-m">
                        Are you sure you want to close this Contract? &nbsp;
                        {((contract.contract_shared && contract.contract_status !== "Close Requested") && `The ${otherParty} will be required to agree to closure.`)}
                    </p>
                    <div className="flex-row ">
                        <button id="contract_end_confirm" className="iblock btn expand pri gap-right-xs" onClick={(e) => handleCloseContract(e)} >End Contract</button>
                        <button className="iblock btn expand sec" onClick={() => setContractClosureModalOpen(false)} >Cancel</button>
                    </div>
                </div>
            </Modal>}

            {closeReqRejectModalOpen &&
            <Modal blurBack={true} hasCloseButton={true} handleClose={() => setCloseReqRejectModalOpen(false)} >
                <div className="flex-column space-btwn flex1 w100" >
                    <p className="content1 light-black multiline gap-below-m">
                        The {otherParty} has requested to close this Contract. Are you sure you want to keep it open?
                    </p>
                    <div className="flex-row ">
                        <button className="iblock btn expand tb gap-right-xs" onClick={(e) => handleRejectClose(e)} >Keep Open</button>
                        <button className="iblock btn expand sec" onClick={() => setCloseReqRejectModalOpen(false)} >Cancel</button>
                    </div>
                </div>
            </Modal>}

            {deletionModalOpen &&
            <ConfirmationModal handleClose={() => setDeletionModalOpen(false)} proceedButtonText="Delete Draft" onSubmit={handleDeleteDraft} >
                <div className="content1 multiline light-black gap-below-m">
                    <p className="gap-below-s">Are you sure you want to delete this contract draft?</p>
                    <p className="heavy" >This step cannot be undone. Type "confirm" to proceed</p>
                </div>
            </ConfirmationModal>}

            <div >
                {(render && !contract.error) &&
                <div className="contract-card">

                    <div className="single-header">
                        <h1 className="title heavy">Contract <span className="light-black">{contract.contract_name ? contract.contract_name : (newDetails.contract_name ? newDetails.contract_name : "Untitled Draft")}</span></h1>

                        {canStartCloseIfNoInvs &&
                            <button id="contract_end" className={(contract.contract_closeable ? "" : "disabled") + " btn sec mini iblock"} onClick={(e) => handleStartClose(e)}>End Contract</button>}
                        {contract.contract_status === "Draft" &&
                        <div
                            onMouseEnter={() => setTrashIsHovered(true)}
                            onMouseLeave={() => setTrashIsHovered(false)}
                            onClick={() => setDeletionModalOpen(true)}  >
                            <IconTrash  height="22px" pathClass={trashIsHovered ? "p-fill" : "g7-fill" } className="td-icon gap-left-s"  style={{marginTop: "-2px"}} />  
                        </div>}
                    </div>

                    <div className="contract-body">
                    {(cantFinishReqdClose || canFinishClose) &&
                    <Warning className="gap-below-m" type="info" >
                        <div>
                            {cantFinishReqdClose &&
                            <div className="iblock">This Contract will end pending confirmation from the {contract.request_from == "Vendor" ? "Purchaser" : "Vendor"}.</div>}

                        </div>
                        {canFinishClose &&
                            <div >The {otherParty} has requested that you close this Contract.</div>
                        }
                    </Warning>}
                    {canFinishClose &&
                    <div className="gap-below-m">
                        <button id="contract_end" className="btn pri min-width iblock gap-right-xs" onClick={() => setContractClosureModalOpen(true)} >Close Contract</button>
                        <button className="btn sec min-width iblock" onClick={() => setCloseReqRejectModalOpen(true)} >Reject</button>
                    </div>}

                    {typeof contract.invitations !== 'undefined' && contract.invitations.length > 0 && 
                        <div className="doc-section gap-below-m">
                            <div className="gap-above-m" >
                                <h3 className="title2 heavy label">Invitations</h3>
                                {contract.invitations.map((invite, index) => {
                                    //mirrors Quote's three-way response (Accept/Decline/RequestRevision, GitHub #632) --
                                    //an APP (approval-stage) invite keeps its original simple Accept/Decline, no
                                    //negotiation options, since it's a single approver's step, not the whole contract
                                    let canNegotiate = !invite.role.startsWith("APP");
                                    return (
                                        <div className={index === contract.invitations.length - 1 ? "" : "gap-below-m"} key={invite.role_id} >
                                            <div className={"gap-below-m content1 light-black"}>You have been invited to act as <span className="heavy">{myRole(invite.role)}</span> on this Contract.</div>
                                            <div className="flex-row gap-below-m"  >
                                                <button id="contract_accept" className="btn pri  min-width gap-right-m" onClick={() => handleAnswerInvite(invite.role_id, invite.role, "Active")}>Accept</button>
                                                <button id="contract_decline" className="btn sec min-width" onClick={() => handleAnswerInvite(invite.role_id, invite.role, "Rejected", "Decline")}>Decline</button>
                                            </div>
                                            {canNegotiate &&
                                            <>
                                                <div className="inputs-wrapper gap-below-xs">
                                                    <div className="input-basic textarea addspace">
                                                        <label className="textarea" htmlFor={"contract_reject_reason_" + invite.role_id}>Request a revision (required message)</label>
                                                        <textarea id={"contract_reject_reason_" + invite.role_id} rows="3" value={rejectionReason} onChange={(e) => setRejectionReason(e.target.value)} />
                                                    </div>
                                                </div>
                                                <button className="btn ter min-width" onClick={() => handleAnswerInvite(invite.role_id, invite.role, "Rejected", "RequestRevision")} disabled={!rejectionReason}>Request Revision</button>
                                            </>}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>}
                        {contract.contract_status === "Declined" &&
                        <Warning className="gap-below-m" >
                            This Contract was declined. It cannot be revised or resent -- create a new Contract if you'd like to try again.
                        </Warning>}
                        {contract.is_rejected &&
                        <Warning className="gap-below-m" >
                            This Contract was rejected{contract.is_rejected_by_first_name && ` by ${contract.is_rejected_by_first_name} ${contract.is_rejected_by_last_name}`}.
                            As a result, it has been pushed back to "Draft" status and all invited parties have been removed. Please revise and resend the Contract, or delete it.
                            {contract.rejection_reason && <div className="gap-above-xs"><span className="heavy">Reason: </span>{contract.rejection_reason}</div>}
                        </Warning>}
                        { contract.contract_name && <WorkflowWizard className="" newParties={newParties} approvalStages={activeStages} />}
                        <div className="doc-section gap-below-m">
                            <h3 className="title2 heavy label iblock gap-right-xs">Details</h3>
                                {(props.match.params.mode !== "editdetails" && userCanEditContract && contract.contract_status !== "Active") &&
                                    <>
                                        <button
                                            onClick={(e) => handleClickEditDetails(e)}
                                            onMouseEnter={() => setEditDetailsHovered(true)}
                                            onMouseLeave={() => setEditDetailsHovered(false)}
                                        >
                                            <Crayon className="iblock" height="13px" pathClass={editDetailsHovered ? "g1-fill" : "g6-fill"} />
                                        </button>
                                    </>
                                }
                            { props.match.params.mode === "editdetails"
                            ?<WorkflowDetailsEdit
                                handleDrop={handleDrop} 
                                selectedFiles={selectedFiles} 
                                removedFiles={removedFiles} 
                                removeSelectedFile={removeSelectedFile} 
                                removeUploadedFile={removeUploadedFile}
                                onChange={onChangeDetails} 
                                onBlur={handleBlurCurrency}
                                onSubmit={onSubmitDetails}
                                isSubmitting={submittingDetails}
                                cancelEditContract={cancelEditContract}
                                details={newDetails}
                                changes={detailChanges}
                            />
                            :<WorkflowDetailsInfo 
                                downloadAttachment={downloadAttachment} 
                                onLink={onLink}
                            />
                            }
                        </div>
                            { contract.contract_name &&
                            <div className="doc-section invert">
                                <h3 className="title2 heavy label iblock gap-right-xs" style={{paddingBottom: "6px"}}>Parties</h3>
                                {(props.match.params.mode !== "editparties" && userCanEditContract && contract.contract_status !== "Pending" && !userSideIsBasic) &&
                                    <>
                                        <button id="edit_parties"
                                            onClick={(e) => handleClickEditParties(e)}
                                            onMouseEnter={() => setEditPartiesHovered(true)}
                                            onMouseLeave={() => setEditPartiesHovered(false)}
                                        >
                                            <Crayon className="iblock" height="13px" pathClass={editPartiesHovered ? "g1-fill" : "g6-fill"} />
                                        </button>
                                    </>
                                }
                                <WorkflowParties
                                    onChange={onChangeParties}
                                    onLink={onLink}
                                    mode={props.match.params.mode}
                                    up={up}
                                    onSubmit={onSubmitParties}
                                    isSubmitting={submittingParties}
                                    newParties={newParties}
                                    onCancelPartyChanges={onCancelPartyChanges}
                                    approvalStages={activeStages}
                                    onSelectTemplate={onSelectTemplate}
                                />
                            </div>
                            }
                    </div>
                </div>
                }
            </div>
        </>
    )
}


const mapStateToProps = () => ({});

export default connect(mapStateToProps, { 
    logout, 
    createMessage, 
    createContract, 
    setActiveSidebarPage, 
    alertPermissionsRequired, 
    editContractAttachment, 
    uploadFileAttachment, 
    getContract, 
    getContractInvitations, 
    clearInvitations, 
    getCompanies, 
    editContract, 
    discardContractDraft, 
    clearContract, 
    respondToContractInvitation, 
    respondToApprovalInvitation,
    setContractDrop,
    setInvoiceDrop,
    setProjectDrop,
    getAcceptedContract,
    deleteContract
})(WorkflowSingle);
